import paymentInstance from '../../../instance'
import paymentModalLoginInstance from '../../../modalLoginInstance'

const getTap2PayConnectionToken = (hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).post('/tap2pay/connectionTokens', {})
}

export default getTap2PayConnectionToken
